// React ve temel hook'lar
import React, { Component, useEffect, useState, useRef } from 'react'

// UI Bileşenleri ve Ant Design
import Flex from 'components/shared-components/Flex';
import { Tabs, Form, Button, message, Input, Row, Col, Card, Menu, Checkbox, InputNumber } from 'antd';
import { Progress, Tooltip, Tag, notification } from 'antd';
import { Modal, Select, Badge, Descriptions, Table, } from 'antd';
import EllipsisDropdown from 'components/shared-components/EllipsisDropdown';

// Sabitler ve Yapılandırma
import { BRANCH_ID, FIRM_ID, FIRM_NAME, ISMULTIIPLESTAMPENABLED } from 'constants/StorageConstant';
import { API_BASE_URL } from 'constants/ApiConstant';
import globalConstant from 'constants/globalConstant';

// İkonlar
import { DeleteOutlined, EditOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { GiftOutlined, CheckOutlined, RetweetOutlined, CloseOutlined, CalendarOutlined, StopOutlined, PhoneOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { BsBasket } from "react-icons/bs";

// Network ve Redux
import network from 'network/network';
import { appListener } from 'utils/redux/actions/appListenerActions';
import { listenerActivate } from 'utils/redux/actions/listenerEnabledActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Yardımcı Fonksiyonlar ve Diğer Bileşenler
import helperFunc from 'helpers/helperFunc';
import { useNavigate, useParams } from 'react-router-dom';
import './Table.css';
import AvatarStatus from 'components/shared-components/AvatarStatus';

// SignalR - Gerçek zamanlı iletişim için
import * as signalR from '@microsoft/signalr';

// SEO ve Çoklu Dil Desteği
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';


// Firma adını localStorage'dan al
const firmName = localStorage.getItem(FIRM_NAME);

const { TabPane } = Tabs;

const BaristaScreen = (props) => {
    // Çoklu dil desteği için
    const { t, i18n } = useTranslation();
    
    // Ana veri state'leri
    const [selectData, setSelectData] = useState([]); // Damga isteklerinin listesi
    const [options, setOptions] = useState([]); // Ürün seçenekleri
    const [loading, setLoading] = useState(false); // Yükleme durumu
    
    // Modal ve ürün seçimi state'leri
    const [coffeeGroup, setCoffeeGroup] = useState(undefined); // Seçili kahve grubu
    const [selectedProduct, setSelectedProduct] = useState(); // Seçili ürün
    const [open, setOpen] = useState(false); // Onay modalının açık/kapalı durumu
    const [CancelOpen, setCancelOpen] = useState(false); // İptal modalının açık/kapalı durumu
    
    // SignalR bağlantısı için ref
    const signalRConnectionRef = useRef(null);
    
    // LocalStorage'dan firma ve şube bilgileri
    const firmId = localStorage.getItem(FIRM_ID);
    const branchId = localStorage.getItem(BRANCH_ID);
    
    // SignalR listener durumu
    const isConnectListener = useRef(false);
    
    // Modal detay state'leri
    const [openModalDetail, setOpenModalDetail] = useState([]); // Onay modalı için seçili kayıt
    const [openModalCancel, setOpenModalCancel] = useState([]); // İptal modalı için seçili kayıt
    
    // Damga sayısı yönetimi
    const [totalStamp, setTotalStamp] = useState(1); // Toplam damga sayısı
    const [rowStampCounts, setRowStampCounts] = useState({}); // Her satır için damga sayıları
    
    // İptal nedenleri
    const [cancelReasons, setCancelReasons] = useState([]); // İptal nedenleri listesi
    const [selectedCancelReasonId, setSelectedCancelReasonId] = useState(cancelReasons.length > 0 ? cancelReasons[0].stampcancelreasonid : undefined);
    const [selectedCancelReason, setSelectedCancelReason] = useState(cancelReasons.length > 0 ? cancelReasons[0].reason : undefined);
    
    // Bildirim durumu
    const [notificationShown, setNotificationShown] = useState(false);

    // Redux'tan listener aktif durumu
    const isListenerActive = props.isListenerActive;

    /**
     * İptal nedeni seçimi değiştiğinde çalışan fonksiyon
     * @param {Object} value - Seçilen değer objesi {value, label}
     */
    const handleSelectChange = (value) => {
        setSelectedCancelReasonId(value.value);
        setSelectedCancelReason(value.label);
    };

    /**
     * Onay modalını açan fonksiyon
     * Hediye isteği mi yoksa normal damga mı olduğuna göre farklı ürün listelerini getirir
     * @param {Object} elm - Seçilen damga isteği kaydı
     */
    const showModal = async (elm) => {
        // Hediye isteği ise hediye ürünlerini getir
        if (elm.isgiftrequest == true) {
            const resultGroup = await network.get("/admin/CoffeeProduct/getAllGiftProducts", {}, false);
            setOptions(resultGroup.data.data);
            setCoffeeGroup(Object.keys(resultGroup.data.data)[0]);
        } else {
            // Normal damga ise tüm ürün gruplarını getir
            const resultGroup = await network.get("/admin/CoffeeProduct/getAllProductsWithGroup", {}, false);
            setOptions(resultGroup.data.data);
            setCoffeeGroup(Object.keys(resultGroup.data.data)[0]);
        }
        setOpen(true);
        setOpenModalDetail(elm);
    };
    /**
     * İptal modalını açan fonksiyon
     * @param {Object} elm - İptal edilecek damga isteği kaydı
     */
    const showCancelModal = (elm) => {
        setCancelOpen(true);
        setOpenModalCancel(elm);
    };
    
    /**
     * Onay modalındaki "Tamam" butonuna tıklandığında çalışır
     * Damga onaylama işlemini başlatır
     */
    const handleOk = () => {
        setOpen(false);
        onFinish(openModalDetail.clientnumber, openModalDetail.isgiftrequest, openModalDetail.clientid)
    };
    
    /**
     * Onay modalını kapatır
     */
    const handleCancel = () => {
        setOpen(false);
    };
    
    /**
     * İptal modalındaki "İptal Et" butonuna tıklandığında çalışır
     * Damga iptal işlemini başlatır
     */
    const handleCancelOk = () => {
        setCancelOpen(false);
        onCancel(openModalCancel.clientnumber, selectedCancelReasonId, selectedCancelReason)
    };

    /**
     * İptal modalını kapatır
     */
    const handleCancelCancel = () => {
        setCancelOpen(false);
    };
    // Kampanya durumu (şu an kullanılmıyor gibi görünüyor)
    const [campaignState, setCampaignState] = useState({
        customerName: "",
        customerPhoneNumber: "",
        customerStampNumber: "",
        sentStampDate: "",
    });
    
    // Damga ve bölüm durumları
    const [stampState, setStampState] = useState(false);
    const [section, setSection] = useState(false);


    /**
     * Bileşen ilk yüklendiğinde çalışır
     * Damga istekleri, iptal nedenleri ve ürün verilerini getirir
     */
    useEffect(() => {
        responseData(); // Bekleyen damga isteklerini getir
        cancelData(); // İptal nedenlerini getir
        productData(); // Ürün verilerini getir
    }, []);

    /**
     * İptal nedenleri yüklendiğinde ilk nedeni varsayılan olarak seçer
     */
    useEffect(() => {
        if (cancelReasons.length > 0) {
            setSelectedCancelReasonId(cancelReasons[0].stampcancelreasonid);
            setSelectedCancelReason(cancelReasons[0].reason)
        }
    }, [cancelReasons]);


    /**
     * SignalR bağlantısını kuran ve gerçek zamanlı damga isteklerini dinleyen useEffect
     * Firma admin'i mi yoksa şube kullanıcısı mı olduğuna göre farklı hub'lara bağlanır
     */
    useEffect(() => {
        if (!isListenerActive) {
            let hubConnection; // Şube kullanıcıları için
            let hubConnectionAdmin; // Firma admin'i için
            
            // Redux'ta listener'ı aktif olarak işaretle
            props.onListenerActive();

            // Bağlantı henüz kurulmamışsa kur
            if (isConnectListener.current === false) {
                // Şube kullanıcıları için stamphub bağlantısı
                hubConnection = new signalR.HubConnectionBuilder()
                    .withUrl(`${API_BASE_URL}/stamphub`, {})
                    .build();

                // Firma admin'i için messagehub bağlantısı
                hubConnectionAdmin = new signalR.HubConnectionBuilder()
                    .withUrl(`${API_BASE_URL}/messagehub`, {})
                    .build();

                // Bağlantıları ref'te sakla
                signalRConnectionRef.current = {
                    hubConnection,
                    hubConnectionAdmin,
                };

                /**
                 * SignalR bağlantısını başlatan fonksiyon
                 * Kullanıcı tipine göre doğru bağlantıyı seçer
                 */
                function startConnection() {
                    const connection = localStorage.getItem('isFirmAdmin') === 'true' ? hubConnectionAdmin : hubConnection;
                    connection.start()
                        .then(() => {
                            isConnectListener.current = true;
                        })
                        .catch(err => {
                            reconnect(); // Hata durumunda yeniden bağlan
                        });
                }

                // Event listener'ları kur (kullanıcı tipine göre)
                if (localStorage.getItem('isFirmAdmin') === 'true') {
                    // Firma admin'i için WhatsApp listener
                    hubConnectionAdmin.on('whatsappListener_' + firmId, onStampRequest);
                    hubConnectionAdmin.on("Expire", onStampRequest);
                } else {
                    // Şube kullanıcısı için stamp listener
                    hubConnection.on('stampListener_' + firmId + '_' + branchId, onStampRequest);
                    hubConnection.on("Expire", onStampRequest);
                }

                /**
                 * Bağlantı koptuğunda yeniden bağlanmayı deneyen fonksiyon
                 */
                function reconnect() {
                    setTimeout(startConnection, 2000); // 2 saniye bekle ve tekrar dene
                }

                // Bağlantı koptuğunda otomatik yeniden bağlanma
                if (localStorage.getItem('isFirmAdmin') === 'true') {
                    hubConnectionAdmin.onclose(reconnect);
                } else {
                    hubConnection.onclose(reconnect);
                }

                // Bağlantıyı başlat
                startConnection();
            }

            // Cleanup fonksiyonu - bileşen unmount olduğunda event listener'ları kaldır
            return () => {
                if (localStorage.getItem('isFirmAdmin') === 'true') {
                    hubConnectionAdmin.off('whatsappListener_' + firmId, onStampRequest);
                    hubConnectionAdmin.off("Expire", onStampRequest);
                } else {
                    hubConnection.off('stampListener_' + firmId + '_' + branchId, onStampRequest);
                }
            };
        }
    }, []);

    /**
     * Yeni damga isteği geldiğinde bildirim sesi çalan fonksiyon
     */
    function playSound() {
        const sound = "/notification.mp3";
        var audio = new Audio(sound);

        // 0.5 saniye bekle ve sesi çal
        setTimeout(() => {
            audio.play();
        }, 500);

        // 2.5 saniye sonra audio nesnesini temizle
        setTimeout(() => {
            audio.remove();
        }, 2500);
    }

    /**
     * SignalR'dan gelen damga isteklerini işleyen fonksiyon
     * Yeni damga, silinen damga veya süresi dolan damga durumlarını handle eder
     * @param {Object} data - SignalR'dan gelen veri
     */
    const onStampRequest = async (data) => {
        let newModel = {};
        
        // Yeni damga isteği geldi ve henüz bildirim gösterilmemişse
        if (data.type == "newstamp" && !notificationShown) {
            let parsedData = JSON.parse(data.payload);

            // Gelen veriyi local model formatına dönüştür
            newModel.tempstampid = parsedData.TEMPSTAMPID;
            newModel.clientid = parsedData.CLIENTID;
            newModel.isgiftrequest = parsedData.ISGIFTREQUEST;
            newModel.status = parsedData.STATUS;
            newModel.insertdate = parsedData.INSERTDATE;
            newModel.clientname = parsedData.CLIENTNAME;
            newModel.clientnumber = parsedData.CLIENTNUMBER;
            newModel.cardcount = parsedData.CARDCOUNT;
            newModel.stampcount = parsedData.STAMPCOUNT;
            
            // Yeni kaydı listeye ekle
            setSelectData((state) => [...state, newModel]);
            
            // Bildirim sesi çal
            playSound();
            
            // Kullanıcıya görsel bildirim göster
            notification.open({
                message: t('stampRequest'),
                description: t('stampReqCome'),
                duration: 3,
                placement: 'topRight',
                icon: <CheckOutlined style={{ color: '#52c41a' }} />
            });
            
            setNotificationShown(true);
        }
        // Damga silindi veya süresi doldu
        else if (data.type == "deletestamp" || data.type == "expiredStamps") {
            responseData(); // Listeyi yenile
        }
    }
    /**
     * Bekleyen damga isteklerini API'dan getiren fonksiyon
     * Kullanıcı tipine göre farklı endpoint'leri kullanır
     */
    const responseData = async () => {
        // Firma admin'i mi yoksa şube kullanıcısı mı kontrolü
        var result = localStorage.getItem('isFirmAdmin') === 'true' 
            ? await network.get("/admin/Stamp/GetAllWaitingStamp", false) // Firma admin endpoint'i
            : await network.get("/admin/Stamp/selectStamp", false); // Şube kullanıcısı endpoint'i

        const { data } = result.data;

        // Status 3 olanları filtrele (muhtemelen tamamlanmış/iptal edilmiş damgalar)
        setSelectData(data.filter(i => i.status != 3))
    }

    /**
     * İptal nedenlerini API'dan getiren fonksiyon
     */
    const cancelData = async () => {
        try {
            const result = await network.get("/admin/Stamp/selectStampCancel", false);
            const { data } = result.data;
            setCancelReasons(data);
            setLoading(false);
        } catch (error) {
            console.error('İptal nedenleri alınamadı:', error);
            setLoading(false);
        }
    };

    /**
     * Ürün verilerini API'dan getiren fonksiyon
     * Şu an sadece API çağrısı yapılıyor, dönen veri kullanılmıyor
     */
    const productData = async () => {
        try {
            var params = {};
            const result = await network.get("/admin/CoffeeProduct/getAllProducts", params, false);
            // TODO: Dönen veri ile bir işlem yapılmıyor, gerekirse implement edilecek
        } catch (error) {
            console.error('Ürün verileri alınamadı:', error);
        }
    }

    /**
     * Ürün seçim durumunu değiştiren fonksiyon
     * Aynı ürün tekrar seçilirse seçimi kaldırır, farklı ürün seçilirse o ürünü seçer
     * @param {number} value - Seçilen ürünün ID'si
     */
    const handleCheckboxChange = (value) => {
        if (selectedProduct === value) {
            setSelectedProduct(null); // Aynı ürün seçildiyse seçimi kaldır
        } else {
            setSelectedProduct(value); // Farklı ürün seçildiyse onu seç
        }
    }



    /**
     * Damga onaylama işlemini gerçekleştiren ana fonksiyon
     * API'ye damga ekleme isteği gönderir ve sonucuna göre kullanıcıya bildirim gösterir
     * @param {string} clientNumber - Müşteri telefon numarası
     * @param {boolean} Status - Hediye isteği mi (true/false)
     * @param {string} rowId - Satır ID'si (damga sayısı takibi için)
     */
    const onFinish = async (clientNumber, Status, rowId) => {
        // Bu satır için belirlenen damga sayısını al (varsayılan 1)
        const totalStampCount = rowStampCounts[rowId] ?? 1;

        // API'ye gönderilecek parametreler
        var params = {
            clientNumber: clientNumber,
            isGiftRequest: Status,
            stampStatus: true,
            productid: (selectedProduct == null || selectedProduct == undefined) ? 0 : selectedProduct,
            totalStamp: totalStampCount
        }
        
        // Damga ekleme API çağrısı
        var result = await network.post(`/admin/Stamp/insertStamp`, params);
        
        if (result.isSuccess) {
            var postResult = result;
            if (postResult.isSuccess) {
                message.success(t('stampOkey'));
                
                // Listeyi yenile
                responseData();

                // Bu satır için damga sayısını 1'e sıfırla
                setRowStampCounts(prev => ({
                    ...prev,
                    [rowId]: 1
                }));
            } else {
                alert(postResult.errorMessage);
            }
            setSection(true);
        } else {
            alert(result.errorMessage);
        }
        
        // Başarı/hata bildirimi göster
        if (result) {
            notification.success({
                message: t('Succesful'),
                description: t('stampOkey'),
                placement: "topRight",
            });
            responseData();
        } else {
            notification.error({
                message: `Hata!`,
                placement: "topRight",
            });
        }
    }



    /**
     * Damga iptal işlemini gerçekleştiren fonksiyon
     * API'ye damga iptal isteği gönderir ve sonucuna göre kullanıcıya bildirim gösterir
     * @param {string} clientNumber - Müşteri telefon numarası
     * @param {number} cancelReasonId - İptal nedeni ID'si
     * @param {string} selectedCancelReason - İptal nedeni açıklaması
     */
    const onCancel = async (clientNumber, cancelReasonId, selectedCancelReason) => {
        // API'ye gönderilecek parametreler
        var params = {
            clientNumber: clientNumber,
            cancelReasonId: cancelReasonId,
            selectedCancelReason: selectedCancelReason
        }
        
        // Damga iptal API çağrısı
        var result = await network.post(`/admin/Stamp/cancelStamp`, params);

        if (result.isSuccess) {
            var postResult = result;
            if (postResult.isSuccess) {
                message.success(t('stampCancelled'));
                responseData(); // Listeyi yenile
            } else {
                alert(postResult.errorMessage);
            }
            setSection(true);
        } else {
            alert(result.errorMessage);
        }
        
        // Başarı/hata bildirimi göster
        if (result) {
            notification.success({
                message: t('Succesful'),
                description: t('stampCancelled'),
                placement: "topRight",
            });
            responseData();
        } else {
            notification.error({
                message: `Hata!`,
                placement: "topRight",
            });
        }
    }

    /**
     * Tarihten saat ve dakika bilgisini ayıklayıp formatlar
     * @param {string} date - Tarih string'i
     * @returns {JSX.Element} HH:MM formatında saat
     */
    const SplitHours = (date) => {
        var t = new Date(date);
        var saat = t.getHours().toString().padStart(2, '0'); // 2 haneli saat
        var dakika = t.getMinutes().toString().padStart(2, '0'); // 2 haneli dakika
        return <>{(saat + ":" + dakika)}</>
    }
    /**
     * Tarihten gün ve ay bilgisini ayıklayıp formatlar
     * Dil ayarına göre Türkçe veya İngilizce ay ismi gösterir
     * @param {string} date - Tarih string'i
     * @returns {JSX.Element} "DD AY" formatında tarih
     */
    const SplitDate = (date) => {
        var aylar = [];

        // Dil ayarına göre ay isimlerini belirle
        if (i18n.language == "tr") {
            aylar = new Array("Ocak", "Şubat", "Mart",
                "Nisan", "Mayıs", "Haziran", "Temmuz", "Agustos", "Eylül",
                "Ekim", "Kasım", "Aralık");
        } else {
            aylar = new Array("January", "February", "March",
                "April", "May", "June", "July", "August", "September",
                "October", "November", "December");
        }

        var t = new Date(date);
        var gun = t.getDate();
        var ay = t.getMonth();
        var yil = t.getFullYear();

        return <>{(gun + " " + aylar[ay])}</>
    }
    /**
     * Müşteri adını gizlilik için formatlar
     * 2 kelimeli isim: "Ad Soyad" -> "Ad S."
     * 3 kelimeli isim: "Ad İkinci Soyad" -> "Ad İkinci S."
     * @param {string} CName - Tam müşteri adı
     * @returns {JSX.Element} Formatlanmış müşteri adı
     */
    const ClientName = (CName) => {
        var Name = CName.split(' ');
        
        if (Name.length == 2) {
            // "Ad Soyad" -> "Ad S."
            return <>{Name[0] + " " + Name[1].slice(0, 1) + "."}</>
        }
        if (Name.length == 3) {
            // "Ad İkinci Soyad" -> "Ad İkinci S."
            return <>{Name[0] + " " + Name[1] + " " + Name[2].slice(0, 1) + "."}</>
        }

        // Tek kelimeli veya beklenmeyen format
        return <>{Name}</>
    }
    /**
     * Müşteri telefon numarasını gizlilik için maskeler
     * Sadece son 4 hanesi görünür: "5551234567" -> "**** *** 4567"
     * @param {string} Number - Tam telefon numarası
     * @returns {JSX.Element} Maskelenmiş telefon numarası
     */
    const ClientNumber = (Number) => {
        // Son 4 hanesi al
        var secNumber = Number.slice(8, 12)
        
        return <>{"**** ***" + " " + secNumber}</>
    }
    const coffeeCircleFunc = (stampNumber) => {
        let list = []
        const coffeCircList = () => {
            for (let i = 1; i <= localStorage.getItem('firmStampCount'); i++) {
                if (i <= stampNumber) {
                    list.push(<Col className='ml-1 d-flex align-items-center justify-content-center'>
                        <span className='d-flex align-items-center justify-content-center' style={{
                            borderWidth: 2,
                            borderStyle: "solid",
                            borderColor: "#FF5A03",
                            borderRadius: '50px',
                            width: '45px',
                            height: '45px',
                            overflow: 'hidden' // Keep the overflow hidden
                        }}>
                            <div style={{
                                width: '95%',  // Set to 80% of the container width
                                height: '90%', // Set to 80% of the container height
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img
                                    src='/img/avatars/Tik.png'
                                    alt="Tick mark"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain', // Changed to contain to ensure the image is fully visible
                                        display: 'block'
                                    }}
                                />
                            </div>
                        </span>
                    </Col>)
                }
                else {
                    list.push(<Col className='ml-1 d-flex align-items-center justify-content-center'>
                        <span className='d-flex align-items-center justify-content-center' style={{
                            borderWidth: 2,
                            borderStyle: "solid",
                            borderColor: "#FF5A03",
                            borderRadius: '50px',
                            width: '45px',
                            height: '45px',
                        }}>
                            <div style={{ fontSize: '25px' }}>{i}</div>
                        </span>
                    </Col>)
                }
            }
            return list;
        }
        return coffeCircList();
    }

    const renderPrompt = (props) => {
        if (props.isProduct === "true" && props.isGift) {
            return (
                <div className='mb-4' style={{ fontSize: '24px', textAlign: "center" }}  >{t('freeCoffeMessage')}</div>
            );
        } else if (props.isProduct === "true" && !props.isGift) {

        }
    }

    /**
     * Tablo kolonlarını tanımlayan fonksiyon
     * Çoklu damga özelliği aktif mi kontrolü yapar ve ona göre kolonları filtreler
     * @returns {Array} Tablo kolon tanımları
     */
    const getColumns = () => {
        // Çoklu damga özelliği aktif mi kontrol et
        const isMultipleEnabled = localStorage.getItem(ISMULTIIPLESTAMPENABLED) === 'true';

        const columns = [
            {
                // Müşteri Bilgileri Kolonu
                title: t('customerInfo'),
                dataIndex: 'GroupName',
                key: 'groupname',
                width: '420px',
                render: (_, record) => (
                    <>
                        {/* Müşteri adı ve kart numarası */}
                        <Row className='d-flex align-items-center'>
                            <Col>
                                <div style={{ fontSize: '25px' }}>
                                    {ClientName(record.clientname)}
                                </div>
                            </Col>
                            <Col>
                                <Tag color='blue' className='ml-2 d-flex align-items-center justify-content-center'>
                                    <div style={{ fontSize: '14px' }}>
                                        {/* Kart numarası hesaplama logic'i */}
                                        {record.cardcount === 0
                                            ? `1.${t('Card')}`
                                            : (record.stampcount === 0
                                                ? (record.cardcount + 1) + `.${t('Card')}`
                                                : record.cardcount + `.${t('Card')}`)
                                        }
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                        
                        {/* Telefon numarası */}
                        <Row>
                            <Col>
                                <div style={{ fontSize: '23px' }}>
                                    {ClientNumber(record.clientnumber)}
                                </div>
                            </Col>
                        </Row>
                        
                        {/* Tarih ve saat bilgileri */}
                        <Row>
                            <span>
                                <Tag style={{ margin: 0 }} color='red'>
                                    <CalendarOutlined className='mt-1' style={{ fontSize: '18px' }} />
                                </Tag>
                            </span>
                            <span className='mx-1' style={{ fontSize: '20px' }}>
                                {SplitDate(record.insertdate)}
                            </span>
                            <span className='mx-1'>
                                <Tag style={{ margin: 0 }} color='red'>
                                    <ClockCircleOutlined className='mt-1' style={{ fontSize: '18px' }} />
                                </Tag>
                            </span>
                            <span className='mr-1' style={{ fontSize: '20px' }}>
                                {SplitHours(record.insertdate)}
                            </span>
                        </Row>
                    </>
                )
            },
            {
                // Damga Bilgileri Kolonu
                title: t('stampInfo'),
                dataIndex: 'id',
                width: '800px',
                align: 'center',
                render: (_, elm) => {
                    return (
                        <div>
                            <Card bodyStyle={{ padding: 0, boxShadow: "5px 8px 24px 5px rgba(105, 119, 128, 0.1)" }}>
                                {/* Damga sayısı gösterimi */}
                                <Row className='my-3 d-flex align-items-center justify-content-center'>
                                    <div style={{ fontSize: '25px' }}>
                                        <b>{elm.stampcount} / {localStorage.getItem('firmStampCount')}</b>
                                    </div>
                                </Row>
                                
                                {/* Damga görsel kartı */}
                                <Row className='mt-2 d-flex align-items-center justify-content-center'>
                                    {coffeeCircleFunc(elm.stampcount)}
                                </Row>

                                {/* Boş alan */}
                                <Row className='my-3 align-items-center justify-content-center'>
                                </Row>
                            </Card>
                        </div>
                    )
                }

            },
            {
                // Damga Sayısı Kolonu (Çoklu damga özelliği için)
                title: t("stampNumber"),
                dataIndex: 'idStamp',
                key: 'stampCount',
                width: '100px',
                align: 'center',
                render: (_, elm) => {
                    // Mevcut satır için seçili damga sayısı (varsayılan 1)
                    const count = rowStampCounts[elm.clientid] ?? 1;
                    // Maksimum eklenebilecek damga sayısı (kalan boş alan)
                    const maxRemaining = parseInt(localStorage.getItem('firmStampCount')) - elm.stampcount;

                    return (
                        <div className='mt-2' style={{ alignItems: 'center', justifyContent: 'center' }}>
                            {/* Eğer kart dolu değilse damga sayısı kontrolünü göster */}
                            {parseInt(localStorage.getItem('firmStampCount')) !== elm.stampcount && (
                                <>
                                    {/* Artırma butonu */}
                                    <Button
                                        type={count === maxRemaining ? "ghost" : "primary"}
                                        disabled={count === maxRemaining}
                                        shape="circle"
                                        style={{ width: 40, marginRight: 8, marginBottom: "10px" }}
                                        icon={<PlusOutlined />}
                                        onClick={() => {
                                            setRowStampCounts(prev => ({
                                                ...prev,
                                                [elm.clientid]: Math.min((prev[elm.clientid] ?? 1) + 1, maxRemaining)
                                            }));
                                        }}
                                    />

                                    {/* Damga sayısı gösterimi */}
                                    <Input
                                        value={count}
                                        readOnly
                                        style={{ width: 50, textAlign: 'center', marginRight: 8 }}
                                    />

                                    {/* Azaltma butonu */}
                                    <Button
                                        type={count === 1 ? "ghost" : "primary"}
                                        disabled={count === 1}
                                        shape="circle"
                                        style={{ width: 40, marginRight: 8, marginTop: "10px" }}
                                        icon={<MinusOutlined />}
                                        onClick={() => {
                                            setRowStampCounts(prev => ({
                                                ...prev,
                                                [elm.clientid]: Math.max((prev[elm.clientid] ?? 1) - 1, 1)
                                            }));
                                        }}
                                    />
                                </>
                            )}
                        </div>
                    );
                }
            },
            {
                // İşlemler Kolonu (Onayla/İptal butonları)
                title: t('Transactions'),
                dataIndex: 'id',
                width: '320px',
                align: 'center',
                render: (_, elm) => {
                    return (
                        <>
                            <div className='d-flex' style={{ justifyContent: "end" }}>
                                {/* Onayla butonu */}
                                <div className='mr-2'>
                                    {elm.isgiftrequest ?
                                        // Hediye isteği için yeşil buton
                                        <Button 
                                            onClick={() => showModal(elm)} 
                                            style={{ 
                                                padding: 0, 
                                                background: "#35A100", 
                                                color: "white", 
                                                width: '140px', 
                                                height: '90px' 
                                            }} 
                                            size={"large"}
                                        >
                                            <b><GiftOutlined style={{ fontSize: 18 }} className='mr-1' /></b>
                                            <span style={{ fontSize: '17px' }}>{t('coffeeGift').toUpperCase()}</span>
                                        </Button>
                                        :
                                        // Normal damga için turuncu buton
                                        <Button 
                                            onClick={() => showModal(elm)} 
                                            style={{ 
                                                padding: 0, 
                                                background: "#FF5A03", 
                                                color: "white", 
                                                width: '140px', 
                                                height: '90px' 
                                            }} 
                                            size={"large"}
                                        >
                                            <b><CheckOutlined style={{ fontSize: 18 }} className='mr-1' /></b>
                                            <span style={{ fontSize: '17px' }}>{t('Stamp').toUpperCase()}</span>
                                        </Button>
                                    }
                                </div>
                                
                                {/* İptal butonu */}
                                <div style={{ width: "90px" }}>
                                    <Button 
                                        onClick={() => showCancelModal(elm)} 
                                        style={{ 
                                            padding: 0, 
                                            width: '100%', 
                                            height: '90px' 
                                        }} 
                                        size={"large"} 
                                        danger
                                    >
                                        <b><CloseOutlined style={{ fontSize: 18 }} /></b>
                                        <span style={{ fontSize: '17px' }}>{t('Cancel').toUpperCase()}</span>
                                    </Button>
                                </div>
                            </div>
                        </>
                    )
                }
            },

        ]

        // Çoklu damga özelliği devre dışıysa damga sayısı kolonunu filtrele
        return columns.filter(column => {
            if (column.dataIndex === 'idStamp') {
                return isMultipleEnabled; // Sadece çoklu damga aktifse göster
            }
            return true; // Diğer tüm kolonları göster
        });
    }

    // const columns = [
    //     {
    //         title: t('customerInfo'),
    //         dataIndex: 'GroupName',
    //         key: 'groupname',
    //         width: '420px',
    //         // sorter: (a, b) => utils.antdTableSorter(a, b, 'campaignsName'),
    //         render: (_, record) => (
    //             <>
    //                 <Row className='d-flex align-items-center  '>
    //                     <Col>
    //                         <div className=' ' style={{ fontSize: '25px' }} >
    //                             {ClientName(record.clientname)}
    //                         </div>
    //                     </Col>
    //                     <Col>
    //                         <Tag color='blue' className='ml-2 d-flex align-items-center justify-content-center'>
    //                             <div style={{ fontSize: '14px' }} >
    //                                 {record.cardcount === 0
    //                                     ? `1.${t('Card')}`
    //                                     : (record.stampcount === 0
    //                                         ? (record.cardcount + 1) + `.${t('Card')}`
    //                                         : record.cardcount + `.${t('Card')}`)
    //                                 }
    //                             </div>
    //                         </Tag>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col>
    //                         <div style={{ fontSize: '23px' }} >{ClientNumber(record.clientnumber)}</div>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <span className=''>
    //                         <Tag style={{ margin: 0 }} color='red'><CalendarOutlined className='mt-1' style={{ fontSize: '18px' }} /></Tag></span>
    //                     <span className='mx-1' style={{ fontSize: '20px' }} >{SplitDate(record.insertdate)}</span>
    //                     <span className='mx-1'>
    //                         <Tag style={{ margin: 0 }} color='red'><ClockCircleOutlined className='mt-1' style={{ fontSize: '18px' }} /></Tag></span>

    //                     <span className='mr-1' style={{ fontSize: '20px' }}> {SplitHours(record.insertdate)}</span>
    //                 </Row>
    //             </>
    //         )
    //     },
    //     {
    //         title: t('stampInfo'),
    //         dataIndex: 'id',
    //         width: '800px',
    //         align: 'center',
    //         render: (_, elm) => {
    //             return (
    //                 <div>
    //                     <div>

    //                         <Card bodyStyle={{ padding: 0, boxShadow: "5px 8px 24px 5px rgba(105, 119, 128, 0.1)" }} >
    //                             <Row className='my-3 d-flex align-items-center justify-content-center'>

    //                                 <div style={{ fontSize: '25px' }} >
    //                                     <b>{elm.stampcount} / {localStorage.getItem('firmStampCount')}</b>
    //                                 </div>
    //                             </Row>
    //                             <Row className='mt-2 d-flex align-items-center justify-content-center'>
    //                                 {coffeeCircleFunc(elm.stampcount)}
    //                             </Row>

    //                             <Row className='my-3 align-items-center justify-content-center'>
    //                             </Row>
    //                         </Card>

    //                     </div>
    //                 </div>

    //             )
    //         }

    //     },
    //     {
    //         title: t("stampNumber"),
    //         dataIndex: 'id',
    //         key: 'stampCount',
    //         width: '100px',
    //         align: 'center',
    //         render: (_, elm) => {
    //             // Mevcut satır için count değeri (yoksa 1)
    //             const count = rowStampCounts[elm.clientid] ?? 1;
    //             // Maksimum eklenebilecek damga sayısı
    //             const maxRemaining = parseInt(localStorage.getItem('firmStampCount')) - elm.stampcount;

    //             return (
    //                 <div className='mt-2' style={{ alignItems: 'center', justifyContent: 'center' }}>
    //                     {parseInt(localStorage.getItem('firmStampCount')) !== elm.stampcount && (
    //                         <>

    //                             <Button
    //                                 type={count === maxRemaining ? "ghost" : "primary"}
    //                                 disabled={count === maxRemaining}
    //                                 shape="circle"
    //                                 style={{ width: 40, marginRight: 8, marginBottom: "10px" }}
    //                                 icon={<PlusOutlined />}
    //                                 onClick={() => {
    //                                     setRowStampCounts(prev => ({
    //                                         ...prev,
    //                                         [elm.clientid]: Math.min((prev[elm.clientid] ?? 1) + 1, maxRemaining)
    //                                     }));
    //                                 }}
    //                             />

    //                             <Input
    //                                 value={count}
    //                                 readOnly
    //                                 style={{ width: 50, textAlign: 'center', marginRight: 8 }}
    //                             />

    //                             <Button
    //                                 type={count === 1 ? "ghost" : "primary"}
    //                                 disabled={count === 1}
    //                                 shape="circle"
    //                                 style={{ width: 40, marginRight: 8, marginTop: "10px" }}
    //                                 icon={<MinusOutlined />}
    //                                 onClick={() => {
    //                                     setRowStampCounts(prev => ({
    //                                         ...prev,
    //                                         [elm.clientid]: Math.max((prev[elm.clientid] ?? 1) - 1, 1)
    //                                     }));
    //                                 }}
    //                             />
    //                         </>
    //                     )}
    //                 </div>
    //             );
    //         }
    //     },
    //     {
    //         title: t('Transactions'),
    //         dataIndex: 'id',
    //         width: '320px',
    //         align: 'center',
    //         render: (_, elm) => {
    //             return (
    //                 <>
    //                     <div style={{ position: 'absolute' }}>

    //                     </div>
    //                     <Row>
    //                         <Col span={14} className='mr-2 '>
    //                             {elm.isgiftrequest ?
    //                                 <Button onClick={() => showModal(elm)} className='' style={{ padding: 0, background: "#FF5A03", color: "white", width: '100%', height: '90px', padding: '0px' }} size={"large"}>
    //                                     <b><GiftOutlined style={{ fontSize: 18 }} className='mr-1 ' /></b>
    //                                     <span style={{ fontSize: '17px' }}>{t('coffeeGift').toUpperCase()}</span>
    //                                 </Button>
    //                                 :
    //                                 <Button onClick={() => showModal(elm)} className='' style={{ padding: 0, background: "#FF5A03", color: "white", width: '100%', height: '90px', padding: '0px' }} size={"large"}>
    //                                     <b><CheckOutlined style={{ fontSize: 18 }} className='mr-1 ' /></b>
    //                                     <span style={{ fontSize: '17px' }}>{t('Stamp').toUpperCase()}</span>
    //                                 </Button>
    //                             }

    //                         </Col>
    //                         <Col span={8}>
    //                             <Button onClick={() => showCancelModal(elm)} className='' style={{ padding: 0, width: '100%', height: '90px' }} size={"large"} danger>
    //                                 <b className='mt-'><CloseOutlined style={{ fontSize: 18 }} /></b>
    //                                 <span style={{ fontSize: '17px' }}>{t('Cancel').toUpperCase()}</span>
    //                             </Button>
    //                         </Col>
    //                     </Row>
    //                 </>
    //             )
    //         }
    //     },

    // ]



    return (
        <>
            {/* Sayfa başlığı için SEO */}
            <Helmet>
                <title>{firmName}{"| Chatshire Admin Panel"}</title>
            </Helmet>
            
            <div>
                {/* Ana tab yapısı */}
                <Tabs defaultActiveKey="1">
                    <TabPane tab={t('stampConfirmationScreen')} key="1">
                        <Card>
                            {/* Damga istekleri tablosu */}
                            <Col span={24}>
                                <Table
                                    pagination={{ defaultPageSize: 50 }}
                                    className="table-striped-rows"
                                    columns={getColumns()}
                                    dataSource={selectData}
                                    rowKey='id'
                                />
                            </Col>
                        </Card>
                    </TabPane>
                </Tabs>

                {/* Damga onay modalı */}
                <Modal
                    open={open}
                    title={<div style={{ fontSize: '22px' }}>{t('Confirmation').toUpperCase()}</div>}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    closeIcon={false}
                    closable={false}
                    width={"fit-content"}
                    style={{ maxWidth: "1100px", minWidth: "800px" }}
                    bodyStyle={{ padding: "18px" }}
                    afterClose={() => {
                        // Modal kapandığında seçimleri temizle
                        setSelectedProduct(null);
                        setCoffeeGroup(undefined);
                    }}
                    footer={[
                        <div className='m-2'>
                            {/* Kapat butonu */}
                            <Button 
                                className='mr-1' 
                                style={{ width: '180px', height: '85px' }} 
                                key="back" 
                                onClick={handleCancel}
                            >
                                <div style={{ fontSize: '23px' }}>{t('Close')}</div>
                            </Button>
                            {/* Onayla butonu - ürün seçimi zorunluysa ve seçilmemişse devre dışı */}
                            <Button 
                                disabled={(selectedProduct == null && localStorage.getItem('Isstampproductselect') === "true")} 
                                className='mr-1' 
                                style={{ width: '180px', height: '85px' }} 
                                key="submit"
                                type={(selectedProduct == null && localStorage.getItem('Isstampproductselect') === "true") ? "ghost" : "primary"} 
                                loading={loading} 
                                onClick={handleOk}
                            >
                                <div style={{ fontSize: '23px' }}>{t('Confirm')}</div>
                            </Button>
                        </div>
                    ]}
                >

                    {/* Modal içerik başlığı - hediye mi normal damga mı kontrolü */}
                    {(openModalDetail.isgiftrequest) ? 
                        <div className='mb-4' style={{ fontSize: '24px', textAlign: "center" }}>
                            {t('freeCoffeMessage')}
                        </div> :
                        <div className='mb-4' style={{ fontSize: '24px', textAlign: "center" }}>
                            {localStorage.getItem('Isstampproductselect') === "true" ? "" : t('confirmCoffeeMessage')}
                        </div>
                    }

                    {/* Ürün seçimi gerekli ise ürün listesini göster */}
                    {localStorage.getItem('Isstampproductselect') === "true" ? (
                        <>
                            {/* Ürün grup butonları */}
                            <div>
                                <div className='mb-3' style={{ maxWidth: "fit-content", display: "flex" }}>
                                    {Object.keys(options).map((groupName) => (
                                        <div className='ml-2' key={groupName}>
                                            <Button
                                                size='large'
                                                type={coffeeGroup === groupName ? "primary" : "default"}
                                                onClick={() => {
                                                    setCoffeeGroup(groupName);
                                                    setSelectedProduct(null); // Grup değiştiğinde ürün seçimini sıfırla
                                                }}
                                            >
                                                {groupName}
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Ayırıcı çizgi */}
                            <hr className='mb-3' style={{ width: "100%", opacity: "50%" }} />

                            {/* Seçili gruptaki ürünleri göster */}
                            {Object.entries(options).filter(([key]) => key == coffeeGroup).map(([groupName, item]) => (
                                <div 
                                    key={groupName}
                                    style={{ 
                                        overflowY: "auto", 
                                        overflowX: "hidden", 
                                        width: "800px", 
                                        maxHeight: "400px", 
                                        scrollbarWidth: "thin" 
                                    }}
                                >
                                    <Row gutter={[16, 16]} align={"stretch"}>
                                        {item.map(i => (
                                            <Col
                                                key={i.productId}
                                                xs={6}
                                                sm={6}
                                                md={6}
                                                lg={6}
                                            >
                                                {/* Ürün seçim kartı */}
                                                <Card
                                                    hoverable
                                                    onClick={() => handleCheckboxChange(i.productId)}
                                                    style={{
                                                        borderColor: selectedProduct === i.productId ? '#1890ff' : '#f0f0f0',
                                                        borderWidth: '2px',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        maxHeight: "100%",
                                                        minWidth: "50px",
                                                        marginBottom: "0px"
                                                    }}
                                                    bodyStyle={{ padding: "10px" }}
                                                >
                                                    <div style={{ 
                                                        display: "flex", 
                                                        alignItems: 'center', 
                                                        wordWrap: "normal", 
                                                        overflow: "hidden" 
                                                    }}>
                                                        {/* Ürün ikonu */}
                                                        <div className='mb-1' style={{ width: "fit-content" }}>
                                                            <img
                                                                src='/img/avatars/product-bag.png'
                                                                alt={i.productName}
                                                                style={{ width: 30, height: 30, borderRadius: '20%' }}
                                                            />
                                                        </div>

                                                        {/* Ürün adı */}
                                                        <div className='mx-auto ml-2' style={{ width: "fit-content" }}>
                                                            <span style={{ fontSize: '14px' }}>{i.productName}</span>
                                                        </div>
                                                    </div>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            ))}
                        </>



                    ) : null}

                </Modal>
                
                {/* Damga iptal modalı */}
                <Modal
                    open={CancelOpen}
                    title={<div style={{ fontSize: '22px' }}>{t('Cancellation').toUpperCase()}</div>}
                    onOk={handleCancelOk}
                    onCancel={handleCancelCancel}
                    width={700}
                    closable={false}
                    footer={[
                        <div className='m-2' key="footer">
                            {/* Kapat butonu */}
                            <Button 
                                className='mr-1' 
                                style={{ width: '180px', height: '85px' }} 
                                key="back" 
                                onClick={handleCancelCancel}
                            >
                                <div style={{ fontSize: '23px' }}>{t('Close')}</div>
                            </Button>
                            {/* İptal et butonu */}
                            <Button 
                                className='mr-1' 
                                style={{ width: '180px', height: '85px' }} 
                                key="submit" 
                                type="primary" 
                                loading={loading} 
                                onClick={handleCancelOk}
                            >
                                <div style={{ fontSize: '23px' }}>{t('Cancel')}</div>
                            </Button>
                        </div>
                    ]}
                >
                    {/* İptal mesajı */}
                    <div style={{ fontSize: '24px' }}>
                        {t('cancelCoffeeMessage')}
                    </div>

                    <br />
                    <br />

                    {/* İptal nedeni seçimi */}
                    <Row>
                        <div className='mr-3 d-flex align-items-center justify-content-center' style={{ fontSize: '24px' }}>
                            {t('cancelReason')}
                        </div>
                        <Select
                            id='stateSelect'
                            labelInValue
                            defaultValue={{ 
                                value: cancelReasons.length > 0 ? cancelReasons[0].stampcancelreasonid : undefined 
                            }}
                            style={{ width: 280 }}
                            className='my-2 mb-1'
                            size="large"
                            onChange={handleSelectChange}
                        >
                            {/* İptal nedenlerini listele */}
                            {cancelReasons.map(reason => (
                                <Select.Option key={reason.stampcancelreasonid} value={reason.stampcancelreasonid}>
                                    {reason.reason}
                                </Select.Option>
                            ))}
                        </Select>
                    </Row>
                </Modal>
            </div>
        </>
    );
}

/**
 * Redux dispatch fonksiyonlarını props'a bağlayan fonksiyon
 * @param {Function} dispatch - Redux dispatch fonksiyonu
 * @returns {Object} Dispatch edilen action'lar
 */
function mapDispatchToProps(dispatch) {
    return {
        appListenerAction: bindActionCreators(appListener, dispatch),
        onListenerActive: bindActionCreators(listenerActivate, dispatch),
    }
}

/**
 * Redux state'ini props'a bağlayan fonksiyon
 * @param {Object} state - Redux store state'i
 * @returns {Object} Bileşende kullanılacak state değerleri
 */
function mapStateToProps(state) {
    return {
        stampList: state.stampReducer.stampList,
        isListenerActive: state.listenerEnabledReducer.isActive
    }
}

// Redux connect ile bileşeni export et, performans için React.memo ile sar
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(BaristaScreen));
